import { Box, Flex, Text, Heading, Divider } from "@chakra-ui/react";
import { Grid, GridItem } from "@chakra-ui/react";
import { Children, type ReactNode } from "react";

interface TopicProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export default function Topic({ title, subtitle, children }: TopicProps) {
  return (
    <Box p={2} borderRadius="md">
      <Heading as="h2" size="lg" mb={1} color="blue.700" fontWeight="bold">
        {title}
      </Heading>
      <Divider borderWidth="1px" mb={4} borderColor="blue.700" />
      {subtitle && (
        <Text fontSize="md" color="blue.700" fontWeight="bold" mb={2}>
          {subtitle}
        </Text>
      )}
      {children}
    </Box>
  );
}
